import React, { useEffect, useState } from "react";
import { APPLY_URL, LOGO_URL } from "./constants";
import { ArrowUpRight } from "lucide-react";

const Header = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="header-nav"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "backdrop-blur-xl bg-[#0a0c27]/75 border-b border-[#d4af37]/15"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-[1400px] mx-auto flex items-center justify-between px-5 md:px-10 py-4">
                <a
                    href="#top"
                    data-testid="header-logo-link"
                    className="flex items-center gap-3 group"
                >
                    <img
                        src={LOGO_URL}
                        alt="Deeper Networking"
                        className="h-10 md:h-11 w-auto"
                        data-testid="header-logo-img"
                    />
                    <span className="hidden sm:block font-display text-[15px] tracking-tight text-[#f6f1e1]/85 group-hover:text-[#f2c652] transition-colors">
                        Deeper Networking
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-8 font-body text-[13px] uppercase tracking-[0.2em] text-[#f6f1e1]/55">
                    <a
                        href="#who"
                        className="hover:text-[#f2c652] transition-colors"
                        data-testid="nav-who"
                    >
                        Who
                    </a>
                    <a
                        href="#layers"
                        className="hover:text-[#f2c652] transition-colors"
                        data-testid="nav-layers"
                    >
                        Layers
                    </a>
                    <a
                        href="#roundtable"
                        className="hover:text-[#f2c652] transition-colors"
                        data-testid="nav-roundtable"
                    >
                        Roundtable
                    </a>
                    <a
                        href="#faq"
                        className="hover:text-[#f2c652] transition-colors"
                        data-testid="nav-faq"
                    >
                        FAQ
                    </a>
                </nav>

                <a
                    href={APPLY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="header-apply-cta"
                    className="group inline-flex items-center gap-2 bg-gradient-to-br from-[#f2c652] to-[#d4af37] hover:from-[#fcc001] hover:to-[#f2c652] text-[#0a0c27] font-display font-semibold text-sm px-4 md:px-5 py-2.5 rounded-sm transition-all hover:-translate-y-0.5 shadow-[0_8px_24px_-8px_rgba(212,175,55,0.6)]"
                >
                    <span className="hidden sm:inline">Apply Now</span>
                    <span className="sm:hidden">Apply</span>
                    <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
            </div>
        </header>
    );
};

export default Header;
